import { z } from "zod";

export const projectMemberControllerSchema = z.object({
	manager: z.string().nullable(),
	deputyManagers: z.array(z.string()).nullable(),
});

export type ProjectMemberControllerSchema = z.infer<typeof projectMemberControllerSchema>;
